/*
 * Authors: mariushirjanu
 * Created: 28/03/2024
 */
import { Injectable } from '@angular/core';
import { ICompanyCountry } from '@type_definitions/datatypes';
import { HttpDataService } from '../../../shared/http/http-data.service';

export interface IPaymentMatchableInvoice {
  id:string;
  invoiceNumber:string;
  orderId:number;
  poNumber:string;
  invoicedTo:string;
  invoiceDate:Date;
  currency:string;
  amount:number;
  remainingAmount:number;
}

export interface IPaymentMatchData {
  invoice:IPaymentMatchableInvoice;
  amount:number;
}

export interface IPaymentMatchTransaction {
  amount:number;
  currency:string;
  issuedTo:ICompanyCountry;
  accountNumber:string;
  transactionDate:Date;
  transactionId:string;
  transactionMessage:string;
  message:string;
  comments:string;
  totalWithBankCosts?:number;
  processingStatus?:PaymentMatchStatus;
}

export enum PaymentMatchStatus {
  NEW = 'NEW',
  PROPOSED = 'PROPOSED',
  MATCHED = 'MATCHED',
  IGNORED = 'IGNORED'
}

const CANCELID_TRANS_ISSUED_TO:string = 'getTransactionsIssuedTo';

@Injectable()
export class PaymentMatcherDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public getMatches(transactionId:string):Promise<IPaymentMatchData[]> {
    return this.httpDataService.doGET(
      `rest/transaction/${transactionId}/payment-matches`,
      undefined,
      undefined,
      'Error getting matches'
    );
  }

  public saveMatches(transactionId:string, data:IPaymentMatchData[], confirm?:boolean):Promise<IPaymentMatchData[]>{
    return this.httpDataService.doPUT(
      `rest/transaction/${transactionId}/payment-matches`,
      { confirm },
      data,
      'Saving matches…',
      'Error saving matches'
    );
  }

  // when no searchTerm -> return the list of 'issued to' transaction IDs
  // when searchTerm -> limit the list to the ones matching the searchTerm
  public getTransactionIssuedTo(transactionId:string, searchTerm?:string):Promise<ICompanyCountry[]> {
    return this.httpDataService.doGET(
      `rest/transaction/${transactionId}/issued-to`,
      { search: searchTerm },
      undefined,
      'Error loading list issuers',
      CANCELID_TRANS_ISSUED_TO
    );
  }

  public getTransactionInvoices(transactionId:string, ccIds?:string, searchTerm?:string):Promise<IPaymentMatchableInvoice[]> {
    return this.httpDataService.doGET(
      `rest/transaction/${transactionId}/invoices`,
      { companyCountryId: ccIds, search: searchTerm },
      undefined,
      'Error loading invoices'
    );
  }

  public saveComment(transactionId:string, comment:string):Promise<void> {
    return this.httpDataService.doPUT(
      `rest/transaction/${transactionId}/comment`,
      undefined,
      comment,
      undefined,
      'Error saving comment'
    );
  }
}